"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionMenu = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var ActionMenuGroup_1 = require("./ActionMenuGroup");
var ActionMenuItem_1 = require("./ActionMenuItem");
var ActionMenu = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.direction, direction = _b === void 0 ? 'br' : _b, _c = _a.padding, padding = _c === void 0 ? null : _c, // Disable Popover's default padding
    wrapperClassName = _a.wrapperClassName, _d = _a.width, width = _d === void 0 ? 's' : _d, props = __rest(_a, ["children", "className", "direction", "padding", "wrapperClassName", "width"]);
    return (react_1.default.createElement(__1.Popover, __assign({ className: classnames_1.default(className, 'ActionMenu__OverlayWrapper'), wrapperClassName: classnames_1.default(wrapperClassName, 'ActionMenu__TriggerWrapper'), popoverContentClassName: "ActionMenu", direction: direction, padding: padding, portal: true, width: width }, props), children));
};
exports.ActionMenu = ActionMenu;
exports.ActionMenu.Group = ActionMenuGroup_1.ActionMenuGroup;
exports.ActionMenu.Item = ActionMenuItem_1.ActionMenuItem;
//# sourceMappingURL=ActionMenu.js.map